<template>
<modal title="Add Models">
  <div style="min-height: 300px">
    <p v-if="availableBindings.length">Add Models to IDOR middleware</p>
    <p v-if="!availableBindings.length">There are no model bindings available to add to this middleware.</p>
    <div class="columns" v-if="availableBindings.length">
      <div class="column">
        <data-selector
          multiple
          :items="availableBindings"
          :value="selected"
          value-key="id"
          label-key="class_name">
          Select Models
        </data-selector>
      </div>
      <div class="column is-narrow is-flex align-end">
        <action-button @click="selectAll" v-if="!selectedAll">Select All</action-button>
        <action-button @click="deselectAll" v-if="selectedAll">Deselect All</action-button>
      </div>
    </div>
  </div>
  

  <template #footer>
    <submit-button :working="saving" @submit="saveBindings">Save</submit-button>
  </template>
</modal>  
</template>
<script>
import { mapGetters } from 'vuex'
import { differenceBy } from 'lodash'

export default {

  data: () => ({
    saving: false,
    selectedAll: false,
    selected: []
  }),

  beforeCreate() {
    this.$store.dispatch('environment/loadModelBindingsList', this.$route.params.environment)
  },

  methods: {
    selectAll() {
      this.selected = this.availableBindings
      this.selectedAll = true
    },
    deselectAll() {
      this.selected = []
      this.selectedAll = false
    },
    saveBindings() {
      this.$store.dispatch('middleware/saveBindings', this.selected.map(binding => binding.id)).then(() => {
        this.$store.commit('middleware/setBindings', this.selected)
        this.$toast.success('Saved')
        this.$close(false)
      })
    }
  },

  computed: {
    ...mapGetters('environment', [
      'modelBindingsList'
    ]),
    ...mapGetters('middleware', [
      'middleware'
    ]),
    availableBindings() {
      return differenceBy(this.modelBindingsList, this.middleware.bindings, 'id')
    }
  }

}
</script>